import { Injectable, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { forEach } from '@angular/router/src/utils/collection';
import { Router } from '@angular/router';

@Injectable()

export class RoleManager {

  constructor(@Inject(DOCUMENT) document, private router: Router) {

  }
  validate(pagename: string) {
    if (localStorage["RoleList"]) {
      var array = [];
      var obj = JSON.parse(localStorage["RoleList"]);
      array = obj[pagename];
      if (array && array.length > 0) {
        array.forEach(items => {
          var _div = document.getElementById(items);
          if (_div) {
            _div.remove();
          }
        });
      }

      array = [];
      array = obj["pages"];
      if (array && array.length > 0) {
        array.forEach(items => {
          if (items === pagename) {
            this.router.navigate(['login']);
          }
        });
      }
    }
  }


}



// WEBPACK FOOTER //
// ./src/app/interface/RoleManager.ts